import {
    GETACCOUNTID_SUCCESS,
    GETACCOUNTID_FAILED,
    RESET_GETACCOUNTID,
    LOADING_GETACCOUNTID,
    NETWORK_ERROR_GETACCOUNTID
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETACCOUNTID:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case GETACCOUNTID_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case GETACCOUNTID_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_GETACCOUNTID:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_GETACCOUNTID:
            return (state = initialState);
        default:
            return state;
    }
};
